import "./styles.scss";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";

import { useWebmasters } from "context/admin/webmasters";

import DashboardContentLayout from "components/layouts/DashboardContentLayout";
import Card from "./components/Card";
import Button from "components/Button";
import CreateAccountModal from "./components/CreateAccountModal";
import ScrollTopMobile from "components/ScrollTopMobile";

import useResponsive from "libs/helpers/useResponsive";

const actions = [
  {
    type: "send_notification",
  },
  {
    type: "create_task",
  },
];

const mainClass = "webmasters-admin-content";

const WebmastersContent = () => {
  const { t } = useTranslation();
  const { max } = useResponsive();

  const { data, init_loading } = useWebmasters();

  const [create_account_modal, setCreateAccountModal] = useState(false);

  return (
    <>
      <DashboardContentLayout
        header={{
          label: t("Webmasters"),
          description: t("List of people in the team."),
        }}
        loading={init_loading}
        actions={actions}
        isAdaptive
      >
        <div className={mainClass}>
          <div className={`${mainClass}__list`}>
            {data?.map((webmaster) => (
              <Card
                key={webmaster._id}
                id={webmaster._id}
                name={`${webmaster.first_name} ${webmaster.last_name}`}
                photo={webmaster?.photo}
                email={webmaster?.email}
                phone={webmaster?.phone}
                priority_count={webmaster?.priority_count}
                status_count={webmaster?.status_count}
              />
            ))}
          </div>
          <div
            className={classnames(`${mainClass}__footer`, {
              [`${mainClass}__footer--outer`]:
                data?.length > 0 && data?.length % 3 === 0,
              [`${mainClass}__footer--outer-tablet`]:
                data?.length > 0 && data?.length % 2 === 0,
            })}
          >
            <Button onClick={() => setCreateAccountModal(true)}>
              {t("Create account")}
            </Button>
          </div>
          {max.sm && (
            <div className={`${mainClass}__scroll`}>
              <ScrollTopMobile />
            </div>
          )}
        </div>
      </DashboardContentLayout>

      <CreateAccountModal
        isOpen={create_account_modal}
        onClose={() => setCreateAccountModal(false)}
      />
    </>
  );
};

export default WebmastersContent;
